const advanceSearchReducer = (state = {
	advanceSearchCriteria: [],
	criterionError: null
}, action) => {
	switch (action.type) {
		case "ADVANCE_SEARCH_CRITERIA":
			return {
				...state,
				advanceSearchCriteria: action.payload
			};
		case "CRITERION_ERROR":
			return {
				...state,
				criterionError: action.payload
			};
		default:
			return state;
	}
};

export default advanceSearchReducer;
